export { NavLink } from './nav-link.component';
